import { render, staticRenderFns } from "./CarouselPreview.vue?vue&type=template&id=31949354"
import script from "./CarouselPreview.vue?vue&type=script&lang=js"
export * from "./CarouselPreview.vue?vue&type=script&lang=js"
import style0 from "./CarouselPreview.vue?vue&type=style&index=0&id=31949354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports